import * as React from "react";
import { forwardRef } from "react";
const SvgShare = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3L17 8L15.59 9.41L13 6.83V16H11L11 6.83L8.41 9.41L7 8L12 3ZM7 10H3V22H21V10H17V12H19V20H5V12H7V10Z", fill: "currentcolor" }));
const ForwardRef = forwardRef(SvgShare);
export default ForwardRef;
